import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { OutboundLink } from "gatsby-plugin-google-analytics";

const MasterclassSection1Background = styled.div`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.gray_dark};
  font: 20px/28px Roboto;
  @media(min-width:1200px){
    height: 677px; 
  }
  @media(max-width:1199px){
    padding-bottom: 50px;
  }
`

const MasterclassSection1Title = styled.div`
  font: 58px/62px Abril Fatface;
  margin-bottom:35px;
  color: ${props => props.theme.colors.gray_dark};
  max-width: 572px;
  @media(max-width:1199px){
    font: 56px/60px Abril Fatface;
  }
  @media(max-width:767px){
    font: 2.5rem/3rem Abril Fatface;
    margin-bottom:17.5px;
  }
`

const MasterclassSection1Subtitle = styled.div`
  font: 28px/32px Abril Fatface;
  margin-bottom:10px;
  color: ${props => props.theme.colors.secondary_green};
`

const FAHeart = styled(FontAwesomeIcon)`
  font-size:1rem;
  color: ${props => props.theme.colors.accent_yellow_hover};
`

const ButtonFill6 = styled(Button)`
  height: 60px;
  color: ${props => props.theme.buttons.primary_button_violet.normal.color} !important;
  background-color: ${props => props.theme.buttons.primary_button_violet.normal.background_color} !important;
  border-color: ${props => props.theme.buttons.primary_button_violet.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props => props.theme.buttons.primary_button_violet.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.hovered.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:3px;
    }
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.primary_button_violet.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
      margin-top:-3px;
      margin-bottom:3px;
    }
  }
  @media(max-width:767px){
    width:100%;
    margin-bottom:20px;
  }
`

export default function MasterclassSection1(props) {
  return (
  <MasterclassSection1Background backgroundColor={props.Background} color={props.TextColor}>

    <img alt="WomenWorks - masterclass batch.02" src="/page-masterclass-section1-img2@2x.png" 
                    css={css`
                    position: absolute;
                    left:0;
                    top:65px;
                    @media(max-width:991px){
                      display: none;
                    }
                    @media(min-width:992px){
                      width:calc(607/1440*100vw);
                      height:calc(695/1440*100vw);
                    }
                    @media(min-width:1200px){
                      height:695px;
                    }
                    @media(min-width:1600px){
                      display: none;
                    }
                `}></img>
      <Container css={css`height:100%;`}>
             <Row css={css`height:100%;`} className="align-items-center" >
                <Col xs="12" lg="5">
                <img alt="WomenWorks - masterclass batch.02" src="/page-masterclass-section1-img2@2x.png" 
                    css={css`
                    @media(max-width:1599px){
                      display: none;
                    }
                    @media(min-width:1600px){
                      display: block;
                      width:100%;
                    }
                `}></img>
                </Col>
                <Col Col xs="12" lg="7">
                <Row>
                  <Col>
                    <MasterclassSection1Subtitle>
                    Example of Our Past Masterclass
                    </MasterclassSection1Subtitle>
                  </Col>
                </Row>
                <Row>
                    <Col>
                    <MasterclassSection1Title>
                    From Home Business to Empire
                    </MasterclassSection1Title>
                    </Col>
                    <Col xs="12" lg="7" css={css`
                          @media(min-width:992px) {
                            display:none;
                          }`}>
                      <img alt="WomenWorks - masterclass batch.02" src="/page-masterclass-section1-img2@2x.png" 
                        css={css`
                          @media(max-width:991px) {
                            object-fit: cover;
                            height: calc(560/1440*100vw);
                            width:100%;
                            margin-bottom:30px;
                            object-position: 15% 15%;
                          }
                          @media(min-width:992px) {
                            display:none;
                          }
                      `}></img>
                    </Col>
                </Row>
                <Row>
                <Col >
                    <p css={css`margin-bottom:24px;min-height:54px;max-height:216px;`}>
                      Gather, discuss, and meet up directly with experts through the series of virtual online sessions to improve your skills, knowledge and network!
                    </p>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                      10 Masterclasses from WomenWorks mentors with specific theme
                    </Col>
                    </Row>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                      Each Masterclass will be held at 10.00-11.30 AM, and can contain presentation, case studies, discussions, group work and Q&A
                    </Col>
                    </Row>
                    <Row >
                    <Col xs="auto" css={css`padding-right:0;`}>
                        <FAHeart icon={faHeart} />
                    </Col>
                    <Col css={css`padding-left:7px;margin-bottom:20px;`}>
                        Finish minimum 5 classes to get an E-Certificate!
                    </Col>
                    </Row>
                    <Row>
                    <Col sm lg="auto" xl="auto" >
                    <OutboundLink target="_blank" rel="noreferrer" href={"mailto:care@womenworks.io" +
                            "?subject=Masterclass%20Inquiry" +
                            "&body=Dear%20WomenWorks%20team,%0D%0A%20I'm%20interested%20to%20learn%20more%20about%20Masterclass%20Program.%20Please%20find%20below%20my%20contact%20information%20where%20you%20can%20reach%20me%20to%20discuss%20further.%0D%0A%0D%0A" +
                            "Name%20:%0D%0A" +
                            "Mobile%20:%0D%0A" +
                            "Email%20:%0D%0A%0D%0A" +
                            "Thank%20you!"}>
                            <ButtonFill6 variant="outline-warning">
                            Start Your Own Masterclass
                            </ButtonFill6>
                      </OutboundLink>
                    </Col>
                    </Row>
                </Col>
                </Row>
            </Col>
            </Row>
      </Container>
  </MasterclassSection1Background>
  )
}

